import IntroducaoPix from "./IntroducaoPix";

export default function Pix() {
  return <IntroducaoPix />;
}
